import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IFormTypes } from '../../data/form-types';
import { NavigationService } from '../../services/navigation.service';
import { AssessmentFormService } from '../../services/assessment-form.service';
import { FormTypes } from '../../constants/form-types.constants';
import { LoadFormDialogComponent } from '../../components/load-form-dialog/load-form-dialog.component';
import { Business } from '../../../core/models/business';
import { BusinessService } from '../../../core/services/business.service';
import { IBusinessDetails } from '../../data/business-details';
import { AssessmentFlagLabels, AssessmentFlags } from '../../data/assessment-flags';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrl: './start-page.component.scss'
})
export class StartPageComponent implements OnInit {
notificationService: any;
formSelectForm: FormGroup<any> | undefined;
applyOrSponsor: string | null = null;
selectedForm: string | null = null;
formTypes!: IFormTypes;
termsAndConditionsAccepted: boolean = false;
nextClicked: boolean = false;

  flags = 0;
  applyFlags = AssessmentFlags.VisaStudyInAustralia | AssessmentFlags.VisaWorkInAustralia | AssessmentFlags.VisaSkilledMigrant | AssessmentFlags.VisaJoinSpouse | AssessmentFlags.VisaJoinParents | AssessmentFlags.VisaJoinChild | AssessmentFlags.VisaVisitAustralia | AssessmentFlags.VisaOwnABusiness | AssessmentFlags.VisaNotSure;
  sponsorFamilyFlags = AssessmentFlags.SponsorChild | AssessmentFlags.SponsorPartner | AssessmentFlags.SponsorParent | AssessmentFlags.SponsorFamilyNotSure;
  sponsorEmployeeFlags = AssessmentFlags.SponsorEmployeeTempWork | AssessmentFlags.SponsorEmployeePermanentResidence | AssessmentFlags.SponsorEmployeeNotSure;
  appealFlags = AssessmentFlags.AppealRefused | AssessmentFlags.AppealCancelled;
  vevoFlags = AssessmentFlags.VerifyVisaDirectEmployee | AssessmentFlags.VerifyVisaContractedWorker | AssessmentFlags.VerifyVisaMyself;
  AssessmentFlags = AssessmentFlags;
  AssessmentFlagLabels = AssessmentFlagLabels;

  hasFlag(flagValue: number): boolean {
    return (this.flags & flagValue) === flagValue;
  }

  hasAnyFlag(flagValue: number): boolean {
    return (this.flags & flagValue) !== 0;
  }

  constructor(
    private navigationService: NavigationService, 
    private assessmentFormService: AssessmentFormService,
    private dialog: MatDialog,
    private businessService: BusinessService
  ) {

    this.businessService.GetInitialAssessmentBusinessDetails().subscribe({
      next: (businessDetails: IBusinessDetails) => {
        if (businessDetails) {
          this.flags = businessDetails.assessmentFlags;
        }else{
           this.flags = this.applyFlags | this.sponsorFamilyFlags | this.sponsorEmployeeFlags | this.appealFlags | this.vevoFlags;
        }
      }
    });
          
    this.formTypes = FormTypes.getAll();
  }  

  ngOnInit(): void {
    var currentModel = this.assessmentFormService.getForm();
    //if we get to start page and we already have a model, we want to reset it as we are starting again.
    if(currentModel){
      this.assessmentFormService.updateFormState(new InitialAssessmentForm());
 
    }
  }

  onApplyOrSponsorChange() {
    this.selectedForm = null;
    if (this.applyOrSponsor === 'resumeSavedForm') {
      this.openLoadFormDialog();
    }
  }

  openLoadFormDialog() {
    const dialogRef = this.dialog.open(LoadFormDialogComponent, {
      panelClass: 'dialog-panel-large',
      maxHeight: 'none'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.action === 'continue') {
        this.selectedForm = this.assessmentFormService.getForm()?.formType || null;
        this.goToNext();
      } else {
        // Reset selection if dialog was cancelled
        this.applyOrSponsor = null;
      }
    });
  }

  goToNext = () => {
    console.log('Next button clicked');
    if(!this.termsAndConditionsAccepted){
      console.log('Terms and Conditions not accepted. Cannot proceed.');
      this.nextClicked = true;
      return;
    }

    if (this.selectedForm) {
      this.assessmentFormService.isApplicant = this.applyOrSponsor === 'apply' || this.applyOrSponsor === 'appeal' || (this.applyOrSponsor === 'vevo' && this.selectedForm === this.formTypes.vevoMyself);
      this.assessmentFormService.applyOrSponsor = this.applyOrSponsor;
      this.navigationService.setSelectedRoute(this.selectedForm);
      console.log('Next button clicked with form selected:', this.selectedForm, 'and applyOrSponsor:', this.applyOrSponsor);

      //Build the application if it doesn't exist
      const form = this.assessmentFormService.getForm();
      if (!form) {

        this.assessmentFormService.createForm(this.selectedForm, this.applyOrSponsor);
      }
       
      this.navigationService.navigateToPage(0);
    }
  }

  onTermsAcceptedChange(isChecked: boolean) {
    this.nextClicked = false;
     this.termsAndConditionsAccepted = isChecked;
  }

  nextButtonDisabled(): boolean {
    return this.formSelectForm?.invalid || !this.applyOrSponsor || !this.selectedForm;
  }


}
